import * as React from 'react';
import { errorHandler } from '../../../error/handler';
import { getVenatura, getVenaturaList } from '../../../fetch/lotto/attributes/venatura';
import { IVenatura } from '../../../interfaces/lotto/attributes/models';
import { normalizer } from '../../../lib/normalizer';
import { useAppDispatch } from '../../../store/hooks';
import { emptyAction, getAction, listAction } from '../../../store/lotto/attributes/venatura/actions';
import { IVenaturaState } from '../../../store/lotto/attributes/venatura/types';
import { endActionToDoAction, startActionToDoAction } from '../../../store/ui/actions';

export const useGetVenatura = (id: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!id) return;
			const actionToDo = 'get-venatura';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const venatura = await getVenatura(id);
				dispatch(getAction(venatura));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
		}
		effect();
	}, [dispatch, id])
}

export const useVenaturaList = (query: number) => {
	const dispatch = useAppDispatch();
	React.useEffect(() => {
		const effect = async () => {
			if (!query) return;
			const actionToDo = 'list-venatura';
			try {
				dispatch(startActionToDoAction({ actionToDo }));
				const { results, items: _items } = await getVenaturaList();
				_items.sort((itemA, itemB) => (!!itemA?.ordinamento && !!itemB.ordinamento) ? itemA.ordinamento - itemB.ordinamento : 0);
				const { list, items } = normalizer<number, IVenatura>(_items, "id");
				const actionPayload: IVenaturaState = {
					results,
					list,
					items
				}
				dispatch(listAction(actionPayload));
				dispatch(endActionToDoAction({ actionToDo, success: true }));
			} catch (err) {
				errorHandler(err, actionToDo);
			}
			return () => {
				dispatch(emptyAction());
			}
		}
		effect();
	}, [dispatch, query])
}
